<template>
  <!-- TKP-218: aramadaki "➕ Yeni … oluştur" seçeneğinin görünür karşılığı — tedbir formundaki "+ Yeni tedbir ekle" ile aynı görünüm -->
  <div class="mt-1" :data-test="dataTest">
    <div v-if="open" class="d-flex align-items-center">
      <input ref="name" class="form-control form-control-sm mr-2" v-model="name" :placeholder="placeholder" :data-test="dataTest + '-name'" @keyup.enter="add" @keyup.esc="close" />
      <button type="button" class="btn btn-sm btn-success mr-1" :disabled="!name.trim()" :data-test="dataTest + '-save'" @click="add">{{ $t("common.add") }}</button>
      <button type="button" class="btn btn-sm btn-secondary" :data-test="dataTest + '-cancel'" @click="close">{{ $t("common.cancel") }}</button>
    </div>
    <!-- TKP-235 m.171/186: bağlantı bir boy büyük (small kalktı) -->
    <span v-else class="text-primary hand" :data-test="dataTest + '-open'" @click="start">{{ label }}</span>
  </div>
</template>

<script>
/** Ad girilip "Ekle"ye basılınca `add(ad)` yayar; seçime ekleme ve kayıt yolu (yeni sözlük kaydı) üst formda. */
export default {
  props: { label: { type: String, required: true }, placeholder: { type: String, default: "" }, dataTest: { type: String, default: "new-entry" } },
  data() {
    return { open: false, name: "" };
  },
  methods: {
    start() {
      this.open = true;
      this.name = "";
      this.$nextTick(() => this.$refs.name && this.$refs.name.focus());
    },
    add() {
      const name = this.name.trim();
      if (!name) return;
      this.$emit("add", name);
      this.close();
    },
    close() {
      this.open = false;
      this.name = "";
    },
  },
};
</script>
